import { createSelector } from 'reselect';

const selectNode = (state: any) => state.node;


export const selectCurrentItem = createSelector([selectNode], (node) => node.current);

export const selectNodeListItems = createSelector([selectNode], (node) => node.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectNodeListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectNodeQueryItems = createSelector([selectNode], (node) => node.query);

export const selectCreatedItem = createSelector([selectNode], (node) => node.create);

export const selectUpdatedItem = createSelector([selectNode], (node) => node.update);

export const selectReadItem = createSelector([selectNode], (node) => node.read);

export const selectDeletedItem = createSelector([selectNode], (node) => node.delete);

export const selectSearchedItems = createSelector([selectNode], (node) => node.search);

export const selectItemsCount = createSelector([selectNode], (node) => node.count);

export const selectItemsFilter = createSelector([selectNode], (node) => node.filter);